import api from '../helpers';
import { FACILITY_DETECTION_PATTERN } from 'src/constants/enterprise';

export default {
  /**
   * Fetch company hierarchy for registration (public endpoint)
   */
  getCompanies: {
    key: 'fetchRegistrationCompanies',
    query: () => {
      return api.get('/api/enterprise/companies');
    },
    mapper: ({ data }) => {
      // Transform array to object keyed by id for tree rendering
      return data.reduce((acc, company) => {
        return {
          ...acc,
          [company._id]: {
            id: company._id,
            companyName: company.name,
            hasChildren: company.hasChildren,
            parentCompanyId: company.parentCompanyId,
            // A company is a facility if its name matches code+number pattern
            isFacility: FACILITY_DETECTION_PATTERN.test(company.name),
          },
        };
      }, {});
    },
  },

  /**
   * Fetch valid parent companies for creating a new facility (public endpoint)
   * Returns companies in tree order with depth pre-computed by backend
   */
  getParentCompanies: {
    key: 'fetchParentCompanies',
    query: () => {
      return api.get('/api/enterprise/parent-companies');
    },
    mapper: ({ data }) => {
      // Data is already in tree order with depth from backend
      return data.map((company) => ({
        id: company._id,
        companyName: company.name,
        parentCompanyId: company.parentCompanyId,
        depth: company.depth,
      }));
    },
  },

  /**
   * Register new account with company selection (public endpoint)
   * Either companyId OR pendingCompany should be provided, not both
   */
  registerWithCompany: {
    key: 'registerAccountWithCompany',
    query: ({ firstName, lastName, email, password, companyId, role, pendingCompany }) => {
      return api.post('/api/enterprise/register', {
        data: {
          firstName,
          lastName,
          email,
          password,
          companyId,
          role,
          pendingCompany,
        },
      });
    },
  },

  /**
   * Search airport codes (public endpoint)
   */
  searchAirportCodes: {
    key: 'searchAirportCodes',
    query: (searchQuery, limit = 20) => {
      return api.get('/api/enterprise/airport-codes', {
        params: {
          q: searchQuery,
          limit,
        },
      });
    },
  },

  /**
   * Lookup specific airport code (public endpoint)
   */
  lookupAirportCode: {
    key: 'lookupAirportCode',
    query: (iataCode, options = {}) => {
      return api.get(`/api/enterprise/airport-codes/${iataCode}`, options);
    },
  },

  /**
   * Create a new company/facility (public endpoint)
   * Note: companySlug is generated by the backend
   */
  createCompany: {
    key: 'createEnterpriseCompany',
    query: ({ name, parentCompanyId, countryId, currency, language, industry }) => {
      return api.post('/api/enterprise/companies', {
        data: {
          name,
          parentCompanyId,
          countryId,
          currency,
          language,
          industry,
        },
      });
    },
  },
};
